export const setTimeoutAsync = (ms: number): Promise<void> =>
  new Promise(resolve => setTimeout(resolve, ms))
